import React from "react";
import { useTranslation } from "react-i18next";
import Button from "@mui/material/Button";
import { Drawer } from "@outpave/ds";
import PaymentLinkPaymentsTable from "./PaymentLinkPaymentsTable";

interface PaymentLinkPaymentsDrawerProps {
  open: boolean;
  paymentLinkId: string | null;
  paymentLinkName?: string;
  onClose: () => void;
}

const PaymentLinkPaymentsDrawer: React.FC<PaymentLinkPaymentsDrawerProps> = ({
  open,
  paymentLinkId,
  paymentLinkName,
  onClose,
}) => {
  const { t } = useTranslation();

  return (
    <Drawer
      open={open}
      onClose={onClose}
      width={720}
      title={paymentLinkName ? [t("Payments"), paymentLinkName] : t("Payments")}
      footer={
        <Button variant="default-outlined" onClick={onClose}>
          {t("Close")}
        </Button>
      }
    >
      {paymentLinkId && (
        <PaymentLinkPaymentsTable paymentLinkId={paymentLinkId} />
      )}
    </Drawer>
  );
};

export default PaymentLinkPaymentsDrawer;
